// extracted by mini-css-extract-plugin
module.exports = {"ToggleWrapper":"styles_ToggleWrapper__3KJuo","ToggleWrapperToggle":"styles_ToggleWrapperToggle__2ScvL","ToggleWrapperInner":"styles_ToggleWrapperInner__2UHQu"};